import { inject } from '@angular/core';
import { ResolveFn, Router } from '@angular/router';
import { StrapiService } from '../services/strapi.service';
import { catchError, map, of } from 'rxjs';

export const eventResolver: ResolveFn<any> = (route, state) => {
  const strapi = inject(StrapiService);
  const event = route.paramMap.get('event');

  const router = inject(Router);

  console.log('RESOLVER EVENT PARAM',event);

  return strapi.getEventInfo(event!).pipe(
    map(eventData => {

      console.log('RESOLVER EVENT DATA',eventData);
      // Check if page data exists (not null/undefined/empty)
      if (!event) {
        router.navigate([`/not-found`]);
        return null;
      }
      return eventData;
    }),
    catchError(error => {
      // Handle API errors by navigating to not-found page
      router.navigate([`/not-found`]);
      return of(null);
    })
  );
};
